import * as React from "react";
const SvgIcFlag = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6 16L6 23H3V16V3V1H6V3H17V6H23V19H10V16H6ZM6 13H13V16H20V9H14V6H6V13Z" fill="currentColor" /></svg>;
export default SvgIcFlag;